function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M112 0H10A10 10 0 000 10v66a10 10 0 0010 10h102a10 10 0 0010-10V10a10 10 0 00-10-10zM82.08 43.42L49.6 62.17a.94.94 0 01-1.42-.82v-37.5a1 1 0 011.42-.83l32.48 18.75a1 1 0 01-.01 1.65z",
  fill: "#fff",
  opacity: 0.85
});

function SvgButtonPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "play button",
    viewBox: "0 0 122 86"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0icGxheV9idXR0b24iIGRhdGEtbmFtZT0icGxheSBidXR0b24iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEyMiA4NiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtvcGFjaXR5OjAuODU7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5wbGF5PC90aXRsZT48ZyBjbGFzcz0iY2xzLTEiPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTExNjAtMzE4SDEwNThhMTAsMTAsMCwwLDAtMTAsMTB2NjZhMTAsMTAsMCwwLDAsMTAsMTBoMTAyYTEwLDEwLDAsMCwwLDEwLTEwdi02NkExMCwxMCwwLDAsMCwxMTYwLTMxOFptLTI5LjkyLDQzLjQyLTMyLjQ4LDE4Ljc1YS45NC45NCwwLDAsMS0xLjQyLS44MnYtMzcuNWExLDEsMCwwLDEsMS40Mi0uODNsMzIuNDgsMTguNzVBMSwxLDAsMCwxLDExMzAuMDctMjc0LjU4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwNDggMzE4KSIvPjwvZz48L3N2Zz4=";
export { SvgButtonPlay as ReactComponent };